import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "revico-community-talk-user-nickname-profile-pic" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "revico-community-talk-user--nickname" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "revico-community-talk-user--profile-pic",
      src: $props.profilePicUrl,
      onError: $setup.replaceDefaultImage
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString($props.nickName), 1 /* TEXT */)
  ]))
}